"use strict";

new WOW().init();

if (document.querySelector('.phone-mask')) {
  document.querySelectorAll('.phone-mask').forEach(function (item) {
    IMask(item, {
      mask: '+{7} (000) 000-00-00'
    });
  });
}

if (document.querySelector('.search form')) {
  document.querySelector('.search form').addEventListener('submit', search, false);
}

if (document.querySelector('.search form .close')) {
  document.querySelector('.search form .close').addEventListener('click', searchClose, false);
}

if (document.querySelector('.menu-toggle')) {
  document.querySelector('.menu-toggle').addEventListener('click', menu, false);
}

if (document.querySelector('.menu-toggle-container .close')) {
  document.querySelector('.menu-toggle-container .close').addEventListener('click', menu, false);
}

if (document.querySelector('.input-counter')) {
  document.querySelectorAll('.input-counter').forEach(function (item) {
    var min = item.getAttribute('data-min');
    var max = item.getAttribute('data-max');
    var btnMinus = item.querySelector('.input-counter-minus');
    var btnPlus = item.querySelector('.input-counter-plus');
    var container = item.querySelector('.input-counter-container');
    var input = container.querySelector('input');

    var inputCounter = function inputCounter(e, direction) {
      e.preventDefault();
      if (!direction) return;
      var value = input.value;
      if (!value) value = min;
      var newValue = parseInt(value) + direction;
      if (min && direction < 0 && newValue < min || max && direction > 0 && newValue > max) newValue = value;
      input.value = newValue;
      var event = new Event('change');
      input.dispatchEvent(event);
    };

    btnMinus.addEventListener('click', function (e) {
      return inputCounter(e, -1);
    }, false);
    btnPlus.addEventListener('click', function (e) {
      return inputCounter(e, 1);
    }, false);
    ['change', 'input'].forEach(function (eventName) {
      input.addEventListener(eventName, function (e) {
        var value = parseInt(input.value);
        if (!value) value = min;
        var newValue = value;
        if (min && newValue < min) newValue = min;else if (max && newValue > max) newValue = max;
        input.value = newValue;
      }, false);
    });
  });
}

if (document.querySelector('.btn-modal')) {
  document.querySelectorAll('.btn-modal').forEach(function (item) {
    item.addEventListener('click', function (event) {
      event.preventDefault();
      eventModalInit(event);
    }, false);
  });
}

if (document.querySelector('.checkbox-custom-listener')) {
  document.querySelectorAll('.checkbox-custom-listener .checkbox-custom input').forEach(function (item) {
    ['change', 'input'].forEach(function (event) {
      item.addEventListener(event, function (e) {
        e.preventDefault();

        if (item.checked) {
          item.closest('.checkbox-custom-listener').classList.add('active');
        } else {
          item.closest('.checkbox-custom-listener').classList.remove('active');
        }
      }, false);
    });
  });
}

if (document.querySelector('.modal')) {
  document.querySelectorAll('.modal').forEach(function (item) {
    item.addEventListener('click', function (event) {
      targetModalClose(event, item);
    });
  });
}

if (document.querySelector('.modal .close')) {
  document.querySelectorAll('.modal .close').forEach(function (item) {
    item.addEventListener('click', function (event) {
      eventModalClose(event);
    }, false);
  });
}

if (document.querySelector('.nomenclature-item-list')) {
  document.querySelectorAll('.nomenclature-item-list input').forEach(function (item) {
    item.addEventListener('change', function (event) {
      event.preventDefault();
      var containerItem = item.closest('.nomenclature-item');
      if (!containerItem) return false;
      var container = containerItem.closest('.nomenclature-order');
      var price = containerItem.querySelector('.nomenclature-item-price span');
      var quantity = containerItem.querySelector('.input-counter-container input');
      var check = containerItem.querySelector('input[type="checkbox"]');
      var id = containerItem.getAttribute('data-id');
      var btnOrder = container.querySelector('.nomenclature-total-btn .btn');
      if (!price || !quantity || !container || !check || !id) return false;
      var total = container.querySelector('.nomenclature-total-price .total-price');
      var isPrice = /^[\d\,\. ]+$/s.test(price.innerHTML);
      var numberPrice = isPrice ? parseFloat(price.innerHTML.replace(/[^\d\.\,]+/, '').replace(',', '.')) : 0,
          listItem = void 0;
      if (!window['nomenclatureList']) window['nomenclatureList'] = [];
      if (window['nomenclatureList'].length > 0) listItem = window['nomenclatureList'].find(function (item) {
        return item.ID === id;
      });
      var itemIndex = window['nomenclatureList'].findIndex(function (item) {
        return item.ID === id;
      });

      if (!listItem && check.checked) {
        listItem = {
          ID: id,
          NAME: check.value,
          QUANTITY: parseInt(quantity.value ? quantity.value : 1),
          PRICE: numberPrice
        };
        window['nomenclatureList'].push(listItem);
      } else if (check.checked) listItem.QUANTITY = parseInt(quantity.value ? quantity.value : 1);

      var totalItemPrice = 0;

      if (!check.checked && event.currentTarget === check && window['nomenclatureList'].length > 0) {
        window['nomenclatureList'].splice(itemIndex, 1);
      }

      window['nomenclatureList'].forEach(function (product) {
        totalItemPrice += product.PRICE * product.QUANTITY;
      });
      if (window['nomenclatureList'].length > 0) btnOrder.classList.remove('disabled');else btnOrder.classList.add('disabled');
      total.innerHTML = formatMoney(totalItemPrice, 2, ",", " ");
    }, false);
  });
}

if (document.querySelector('#modal-order')) {
  document.querySelector('#modal-order').addEventListener('modal-open', function (e) {
    if (!window['nomenclatureList'] || window['nomenclatureList'].length === 0) {
      modalCloseAll();
      return false;
    } else {
      var mail = '';
      window['nomenclatureList'].forEach(function (item) {
        mail += item.NAME + ' x ' + item.QUANTITY + (item.PRICE ? ', ' + item.PRICE + ' ₽' : '') + "||";
      });
      if (mail) e.target.querySelector('input[name="nomenclature"]').value = mail;
    }
  }, false);
}

function formatMoney(number, decPlaces, decSep, thouSep) {
  decPlaces = isNaN(decPlaces = Math.abs(decPlaces)) ? 2 : decPlaces, decSep = typeof decSep === "undefined" ? "." : decSep;
  thouSep = typeof thouSep === "undefined" ? "," : thouSep;
  var sign = number < 0 ? "-" : "";
  var i = String(parseInt(number = Math.abs(Number(number) || 0).toFixed(decPlaces)));
  var j = (j = i.length) > 3 ? j % 3 : 0;
  return sign + (j ? i.substr(0, j) + thouSep : "") + i.substr(j).replace(/(\decSep{3})(?=\decSep)/g, "$1" + thouSep) + (decPlaces ? decSep + Math.abs(number - i).toFixed(decPlaces).slice(2) : "");
}

function eventModalClose(event) {
  if (event) event.preventDefault();
  var modal = event.currentTarget.closest('.modal');

  if (modal) {
    modal.classList.remove('active');
    document.querySelector('html').classList.remove('modal-open');

    var _event = new Event("modal-close");

    modal.dispatchEvent(_event);
  }

  return false;
}

function eventModalInit(event) {
  event.preventDefault();
  if (event.target.classList.contains('disabled')) return;
  var container = event.currentTarget.getAttribute('data-modal');
  modalOpen(container);
  return false;
}

function modalOpen() {
  var id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  if (!id) return;
  var modal = document.getElementById(id);
  document.querySelectorAll('.modal').forEach(function (modalOther) {
    modalOther.classList.remove('active');
  });

  if (modal) {
    modal.classList.add('load');
    setTimeout(function () {
      modal.dispatchEvent(new Event('modal-open'));
      modal.classList.remove('load');
      modal.classList.add('active');
      document.querySelector('html').classList.add('modal-open');
    }, 100);
  } else {
    document.querySelector('html').classList.remove('modal-open');
  }

  return false;
}

function targetModalClose(event, modal) {
  if (event.target == modal) {
    modal.classList.remove('active');
    document.querySelector('html').classList.remove('modal-open');

    var _event2 = new Event("modal-close");

    modal.dispatchEvent(_event2);
    var form = modal.querySelector('form');
    if (form) form.reset();
  }
}

function modalCloseAll() {
  var modal = document.querySelectorAll('.modal.active');

  if (modal) {
    modal.forEach(function (item) {
      item.classList.remove('active');
      document.querySelector('html').classList.remove('modal-open');
      var event = new Event("modal-close");
      item.dispatchEvent(event);
      var form = item.querySelector('form');
      if (form) form.reset();
    });
  }

  return false;
}

function search(event) {
  if (!document.querySelector('.search input[type="text"]').classList.contains('hidden')) return true;
  event.preventDefault();
  document.querySelector('.search input[type="text"]').classList.remove('hidden');
  document.querySelector('.btn-search').classList.add('active');
  document.querySelector('.btn-search').closest('form').classList.add('active');
  return false;
}

function searchClose(event) {
  event.preventDefault();
  document.querySelector('.search input[type="text"]').classList.add('hidden');
  document.querySelector('.btn-search').classList.remove('active');
  document.querySelector('.btn-search').closest('form').classList.remove('active');
  return false;
}

function menu(event) {
  if (!event.target.closest('.menu-toggle-wrapper').querySelector('.menu-toggle-container').classList.contains('open')) {
    event.target.closest('.menu-toggle-wrapper').querySelector('.menu-toggle-container').classList.add('open');
    document.querySelector('body').classList.add('modal-open');
    event.target.classList.add('open');
  } else {
    event.target.closest('.menu-toggle-wrapper').querySelector('.menu-toggle-container').classList.remove('open');
    document.querySelector('body').classList.remove('modal-open');
    event.target.classList.remove('open');
  }

  return false;
}

function menuCLose(event) {
  event.target.closest('.menu-toggle-wrapper').querySelector('.menu-toggle-container').classList.remove('open');
  document.querySelector('body').classList.remove('modal-open');
  event.target.classList.remove('open');
  return false;
}

if (document.querySelector('select.js-select')) {
  document.querySelectorAll('select.js-select').forEach(function (item) {
    styleSelect(item);
  });
}

if (document.querySelector('label.file')) {
  document.querySelectorAll('label.file').forEach(function (item) {
    var input = item.querySelector('input[type="file"]');
    var text = item.querySelector('span');
    input.addEventListener('change', function (event) {
      event.preventDefault();
      var name = event.target.files[0].name;
      text.textContent = name;
    }, false);
  });
}